import { MaintenanceBanner, OfflineBanner } from '@/ui/components';
import useDevelopmentTools from '@/ui/layouts/rootLayout/components/useDevelopmentTools';
import { FC, PropsWithChildren, useEffect, type JSX } from 'react';

const ENABLE_AWIN_TRACKING =
  import.meta.env.VITE_ENABLE_AWIN_TRACKING === 'true';

type Props = {
  pageBanners?: JSX.Element[];
  className?: string;
};
const PageWrapper: FC<PropsWithChildren<Props>> = ({
  pageBanners,
  children,
  className,
}: PropsWithChildren<Props>): JSX.Element => {
  useDevelopmentTools();

  // Awin say to include their 'master tag' on every page.
  // Their docs don't acknowledge the existence of these things called 'SPA's,
  // so we need to dynamically add/remove it with every page-level component.
  useEffect(() => {
    let awMastertag: HTMLScriptElement;
    if (ENABLE_AWIN_TRACKING) {
      awMastertag = document.createElement('script');
      awMastertag.setAttribute('defer', 'defer');
      awMastertag.src = '/awin-master-tag.js';

      awMastertag.type = 'text/javascript';
      document.getElementsByTagName('body')[0].appendChild(awMastertag);
    }
    return () => {
      if (ENABLE_AWIN_TRACKING) {
        try {
          document.body.removeChild(awMastertag);
        } catch (err) {}
      }
    };
  }, []);

  return (
    <div
      className={`relative flex h-screen max-h-screen w-full flex-col ${
        className ? className : ''
      }`}
    >
      <div className="sticky top-0">
        <OfflineBanner />
        <MaintenanceBanner />
        {pageBanners}
      </div>
      <div className="page-wrapper-inner relative grow overflow-y-auto">
        {children}
      </div>
    </div>
  );
};

export default PageWrapper;
